import { create } from 'zustand';

type OnboardingStore = {
  isOnboardingPage: boolean;
  setIsOnboardingPage: (value: boolean) => void;
};

export const useOnboarding = create<OnboardingStore>((set) => ({
  isOnboardingPage: false,
  setIsOnboardingPage: (value) => set({ isOnboardingPage: value }),
}));